import React from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { WocommCategoriesTable } from "./wocomm-categories-table/WocommCategoriesTable";

export default function WocommCategoriesCard() {
 
  return (
    <Card>
          <CardHeader title='Woocommerce Categories'>
            <CardHeaderToolbar>
             
            </CardHeaderToolbar>
          </CardHeader>{" "}
      <CardBody>
        <WocommCategoriesTable />
      </CardBody>
    </Card>
  );
}
